import { useMemo, useState } from 'react';

import { SelectedFilters } from './types/Filter/Filter';
import { UnitTour } from './types/Unit/Unit';
import FiltersHeader from './components/FiltersHeader/FiltersHeader';
import filterUnitTours from './utils/filterUnitTours/filterUnitTours';
import TABLE_COLUMNS from './constants/TableColumns';
import UnitTable from './components/UnitTable/UnitTable';
import useFilters from './hooks/useFilters/useFilters';
import useUnitTours from './hooks/useUnitTours/useUnitTours';

import styles from './App.module.scss';

function App() {
    const { data: unitTours, error, loading } = useUnitTours();

    const availableFilters = useFilters(unitTours);
    const [selectedFilters, setSelectedFilters] = useState<SelectedFilters>({});

    const availableColumns = useMemo(
        () =>
            TABLE_COLUMNS.filter((column) => {
                const columnData = unitTours
                    .map((unitTour) =>
                        column.getValue
                            ? column.getValue(unitTour)
                            : unitTour[column.key as keyof UnitTour]
                    )
                    .filter(Boolean);

                const isColumnEmpty = columnData.length === 0;

                return !isColumnEmpty;
            }),
        [unitTours]
    );

    const filteredUnitTours = useMemo<UnitTour[]>(
        () => filterUnitTours(unitTours, availableFilters, selectedFilters),
        [unitTours, availableFilters, selectedFilters]
    );

    return (
        <div className={styles.app}>
            {error ? <div className={styles.message}>{`${error}`}</div> : null}
            {loading ? (
                <div className={styles.message}>Loading...</div>
            ) : (
                <>
                    <FiltersHeader
                        filters={availableFilters}
                        selectedFilters={selectedFilters}
                        onFiltersChange={setSelectedFilters}
                    />
                    <UnitTable
                        columns={availableColumns}
                        data={filteredUnitTours}
                    />
                </>
            )}
        </div>
    );
}

export default App;
